import { render } from "./Intro.vue?vue&type=template&id=a581f460"
import script from "./Intro.vue?vue&type=script&lang=ts"
export * from "./Intro.vue?vue&type=script&lang=ts"
script.render = render

export default script